import { useEffect, useMemo, useState } from "react";
import { Calendar } from "../components/ui/calendar";
import { api } from "../lib/api";

// Public availability calendar. mode "view" (read-only legend) or "pick" (selectable available days).
export default function AvailabilityCalendar({ mode = "view", selected, onSelect, month, onMonthChange, className = "" }) {
  const [availability, setAvailability] = useState({});
  const [internalMonth, setInternalMonth] = useState(new Date());
  const activeMonth = month || internalMonth;

  useEffect(() => {
    api.get("/availability").then((res) => setAvailability(res.data.availability)).catch(() => {});
  }, []);

  const byStatus = useMemo(() => {
    const out = { available: [], full: [], closed: [] };
    Object.entries(availability).forEach(([dateStr, info]) => {
      const d = new Date(dateStr + "T00:00:00");
      if (out[info.status]) out[info.status].push(d);
    });
    return out;
  }, [availability]);

  const handleMonthChange = (m) => {
    setInternalMonth(m);
    onMonthChange?.(m);
  };

  const disabledMatcher = (date) => {
    const key = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`;
    return availability[key]?.status !== "available";
  };

  return (
    <div className={className} data-testid="availability-calendar">
      <Calendar
        mode="single"
        month={activeMonth}
        onMonthChange={handleMonthChange}
        selected={selected}
        onSelect={mode === "pick" ? onSelect : undefined}
        disabled={mode === "pick" ? [{ before: new Date() }, disabledMatcher] : undefined}
        modifiers={{ available: byStatus.available, full: byStatus.full, closed: byStatus.closed }}
        modifiersClassNames={{ available: "cal-day-available", full: "cal-day-full", closed: "cal-day-closed" }}
        className="rounded-xl border border-slate-200 bg-white p-4 shadow-sm"
      />
      <div className="mt-4 flex flex-wrap gap-4 text-xs text-slate-500" data-testid="availability-legend">
        <span className="flex items-center gap-2"><span className="h-3 w-3 rounded-full bg-sky-400" /> Available</span>
        <span className="flex items-center gap-2"><span className="h-3 w-3 rounded-full bg-red-300" /> Fully booked</span>
        <span className="flex items-center gap-2"><span className="h-3 w-3 rounded-full bg-slate-200" /> Not running</span>
      </div>
    </div>
  );
}
